import { tw } from "~/utils";

interface LoadingBarProps {
  floating?: boolean;
  className?: string;
}

const LoadingBar = ({ floating = true, className }: LoadingBarProps) => (
  <div
    className={tw(
      `${
        floating ? "absolute" : "relative"
      } top-0 z-[100] h-1 w-full overflow-hidden bg-charcoal/20`,
      className
    )}
  >
    <div className="size-full origin-[0%_50%] animate-indeterminateAnimation bg-purple" />
  </div>
);

export default LoadingBar;
